export default Backbone.View.extend({
  events: {
    click: 'disableFilter',
  },

  initialize(options) {
    this.fieldName = options.fieldName;
    this.value = options.value;
    this.model.on(`change:${this.fieldName}`, _.bind(this.onFieldChanged, this));
    this.onFieldChanged();
  },

  onFieldChanged() {
    const inList = _.contains(this.model.get(this.fieldName), this.value);

    if (inList) {
      this.$el.removeClass('hidden');
    } else {
      this.$el.addClass('hidden');
    }
  },

  disableFilter() {
    const list = this.model.get(this.fieldName);
    this.model.set(this.fieldName, _.without(list, this.value));
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/applied_filter_list_pill_view.js